var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opc-cart-item--inline"},[(_vm.is)?_c('span',{staticClass:"opc-cart-item__text text-capitalized"},[_vm._v(_vm._s(_vm.licenseDisplay))]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }